{
  "seo": {
    "title": "Compare Plans — Free vs Family",
    "description": "Compare CuriPop Free and Family plans with a clear feature matrix to choose what is best for your family.",
    "keywords": "compare plans, free vs family, kids learning app pricing comparison"
  },
  "hero": {
    "title": "Compare Free vs Family Plan",
    "subtitle": "Every feature and limit in one place so parents can decide quickly."
  },
  "table": {
    "tagline": "Transparent feature matrix",
    "title": "What changes when you upgrade",
    "headers": {
      "feature": "Feature",
      "free": "Free",
      "family": "Family"
    }
  },
  "rows": [
    {
      "feature": "Question access",
      "free": "12/day (rotating)",
      "family": "Unlimited"
    },
    {
      "feature": "Quiz modes",
      "free": "",
      "family": ""
    },
    {
      "feature": "Printables library",
      "free": "Free printables when available",
      "family": "Subscriber printables when available"
    },
    {
      "feature": "Badges & favorites",
      "free": "",
      "family": ""
    },
    {
      "feature": "Parent dashboard",
      "free": "",
      "family": ""
    },
    {
      "feature": "Child profiles",
      "free": "Multiple",
      "family": "Multiple"
    }
  ],
  "cta": {
    "title": "Try before you commit",
    "subtitle": "Start free now, then move to Family when your child needs unlimited exploration and quizzes.",
    "primary": "Start Free",
    "secondary": "View Pricing"
  }
}
